/**
 * Menu grid tag filter.
 *
 * The pills are rendered `hidden` by Liquid and revealed here. That ordering is
 * deliberate: if this script never runs, the visitor sees the full grid with no dead
 * controls, rather than pills that do nothing when clicked.
 *
 * Filtering is client-side over already-rendered cards, so there is no request and no
 * layout flash. Cards carry their tags in `data-eb-tags`, lower-cased by Liquid.
 */
(() => {
  const init = (root) => {
    const filters = root.querySelector('[data-eb-filters]');
    const grid = root.querySelector('[data-eb-menu-grid]');
    if (!filters || !grid) return;

    const cards = Array.from(grid.querySelectorAll('[data-eb-tags]'));
    const empty = root.querySelector('[data-eb-menu-empty]');
    if (!cards.length) return;

    filters.hidden = false;

    filters.addEventListener('click', (event) => {
      const button = event.target.closest('[data-eb-filter]');
      if (!button) return;

      const wanted = button.dataset.ebFilter;

      for (const pill of filters.querySelectorAll('[data-eb-filter]')) {
        pill.classList.toggle('is-active', pill === button);
      }

      let shown = 0;
      for (const card of cards) {
        const tags = (card.dataset.ebTags || '').split(',').map((t) => t.trim());
        const match = wanted === '*' || tags.includes(wanted);
        card.hidden = !match;
        if (match) shown += 1;
      }

      if (empty) empty.hidden = shown !== 0;
    });
  };

  const boot = () => {
    for (const section of document.querySelectorAll('.eb-menu')) init(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('.eb-menu');
    if (section) init(section);
  });
})();
